import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
// import { useIntl } from "react-intl";

interface DialogErrorProps {
  onClose: () => void;
  open: boolean;
  title?: string;
  body?: string | JSX.Element;
  confirmText?: string;
  width?: number;
  testId?: string;
}

const useStyles = makeStyles(
  () => ({
    root: {
      "& .MuiPaper-root": {
        minWidth: 400,
        borderRadius: 16
      },
      "& .MuiDialogTitle-root": {
        paddingTop: "3.2rem",
        paddingBottom: "1.2rem"
      },
      "& .MuiDialogActions-root": {
        paddingTop: "2.8rem",
        paddingBottom: "3.2rem"
      }
    },
    dialogContent: {
      padding: "12px 24px !important"
    },
    dialogAction: {
      borderTop: "none"
    },
    btnAction: {
      height: 48,
      width: "100%"
    }
  }),
  { name: "DialogError" }
);

const DialogError: React.FC<DialogErrorProps> = ({
  onClose,
  open,
  title,
  body,
  confirmText,
  width,
  testId
}) => {
  // const intl = useIntl();
  const classes = useStyles();
  return (
    <Dialog
      open={open}
      onClose={onClose}
      className={classes.root}
      data-testid={testId ?? "dialogError"}
    >
      <DialogTitle>
        <MyTypography variant={"h6"}>
          {/* {intl.formatMessage({ defaultMessage:  })} */}
          {title || "ไม่สามารถดำเนินการได้"}
        </MyTypography>
      </DialogTitle>
      <DialogContent
        style={{
          width
        }}
        className={classes.dialogContent}
      >
        <MyTypography variant={"body2"}>
          {body || "กรุณากลับไป เพื่อกรอกข้อมูลที่ต้องการให้ครบถ้วน"}
        </MyTypography>
      </DialogContent>
      <DialogActions className={classes.dialogAction}>
        <Button
          id="backButton"
          data-testid="backButton"
          variant={"contained"}
          color={"primary"}
          className={classes.btnAction}
          onClick={onClose}
        >
          <MyTypography variant={"body1"} style={{ color: "#ffffff" }}>
            {confirmText || "กลับไป"}
          </MyTypography>
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogError;
